import React, { Component } from 'react';
import img from '../../../assets/Agency/AgencyEnrollments_Content/89f8adec68a46da97414de0a36135be9_html_445bf62413da2bb6.png';
class AgencyEnrollmentsContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Agency Enrollment:</b></p>
                <p>Agency can view members enrolled in application in Our Enrollment menu, Agency can view members enrolled under different brokers by selecting from brokers dropdown list. .</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default AgencyEnrollmentsContent;
